import { fetchWrapper, objectToQueryParams } from '../utils';

const baseUrl = process.env.REACT_APP_BASE_API + 'client/products';

export const getProduct = async (id) => {
  const url = `${baseUrl}/${id}`;
  return await fetchWrapper.get(url);
}

export const getProducts = async (filters) => {
  const url = `${baseUrl}?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const getProductsFromCart = async (filters) => {
  const url = `${baseUrl}/cart?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}